import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, Jsonp} from '@angular/http';
import { CanActivate, Router } from "@angular/router";
import {APIURLTEST, APIURLDEV, APIURLPROD} from "../globals";
import { Subject, Subscription } from 'rxjs/Rx';
import * as moment from 'moment';
import { isDevMode } from '@angular/core';

@Injectable()
export class AuthService implements CanActivate{
  public urlAuth = "manager/auth/login";
  public headers: Headers;
  public APIURL;
  public subject = new Subject();
  public subject$ = this.subject.asObservable();
  constructor(public http: Http, public router: Router) {

    if(this.getUserLogued()){
      if(!this.checkExpirationDate()) {
        this.setHeaders();
      }else{
        this.router.navigate(["/login"]);
      }
    }

    this.checkEnviroment();
  }

  protected saveOnLocalStorage(user) {
    user = JSON.stringify(user);
    localStorage.setItem("user",user);
  }

  protected getFromLocalStorage() {
    return JSON.parse(localStorage.getItem("user"));
  }

  protected getUserLogued(){
    return (localStorage.getItem("user") != null) ? true : false;
  }

  protected checkExpirationDate(){
    var user = JSON.parse(localStorage.getItem("user"));
    var expiration = user["expires"];
    if(expiration <= Date.now()){
        this.setLoginTrue(false);
        localStorage.removeItem("user");
        return true;
    }else{
        return false;
    }

  }
  public checkEnviroment(){
    var environment = window.location.hostname;
    switch (environment) {
      case'localhost':
        this.APIURL = APIURLDEV;
      break;
      case 'clintu-manager.azurewebsites.net':
        this.APIURL = APIURLPROD;
      break;
      case 'manager.clintu.com':
        this.APIURL = APIURLPROD;
      break;

      default:
      this.APIURL = APIURLPROD;
    }
  }

  public setLoginTrue(value){
    this.subject.next(value);
  }

  public getIfLogged(){
    return this.subject.asObservable();
  }

  private setHeaders() {
    let token = this.getFromLocalStorage().token;
    this.headers = new Headers();
    this.headers.append("Content-type","application/json");
    this.headers.append("X-Access-Token",token);
    this.headers.append("X-Key","admin");
  }

  public canActivate() {
    if(this.getUserLogued()){
      return this.getUserLogued();
    }else{
      this.router.navigate(['/login']);
      return false;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/injections/auth.service.ts